import React from 'react';
import { useLang } from '../context/LanguageContext';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import ContactStrip from '../components/ContactStrip';
import { Info } from 'lucide-react';
import SEO from '../components/SEO';
import { getSeo, SEO_KEYWORDS } from '../data/seo';

const EqBlock = ({ title, body, equations, caption }) => (
  <div className="rounded-xl bg-white border border-slate-200 p-6 lg:p-8">
    <h3 className="text-lg font-bold text-slate-900">{title}</h3>
    <p className="mt-3 text-sm text-slate-600 leading-relaxed">{body}</p>
    <div className="mt-5 space-y-2.5">
      {equations.map((eq, i) => (
        <div key={i} className="rounded-lg bg-slate-900 px-4 py-3 font-mono text-[13.5px] text-blue-100 tracking-wide">
          {eq}
        </div>
      ))}
    </div>
    {caption && <p className="mt-3 text-[12px] text-slate-500 italic leading-relaxed">{caption}</p>}
  </div>
);

const Reaction = () => {
  const { t, lang } = useLang();
  const seo = getSeo('reaction', lang);
  return (
    <div>
      <SEO title={seo.title} description={seo.description} path="/reaktion" lang={lang} keywords={SEO_KEYWORDS[lang]} />
      <PageHeader label={t('reaction.label')} title={t('reaction.title')} lead={t('reaction.lead')} imageKey="powderMagnifier" />
      <section className="bg-slate-50 py-16 lg:py-24">
        <div className="container-wide grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-6">
          <Reveal>
            <EqBlock title={t('reaction.block1Title')} body={t('reaction.block1Body')} equations={t('reaction.eq1')} caption={t('reaction.schematicNote')} />
          </Reveal>
          <Reveal delay={100}>
            <EqBlock title={t('reaction.block2Title')} body={t('reaction.block2Body')} equations={t('reaction.eq2')} caption={t('reaction.schematicNote')} />
          </Reveal>
        </div>
        <div className="container-wide mt-6">
          <div className="flex items-start gap-4 rounded-xl border border-blue-200 bg-blue-50 px-6 py-5">
            <Info className="w-5 h-5 text-blue-700 shrink-0 mt-0.5" />
            <p className="text-[14.5px] text-slate-700 leading-relaxed">{t('reaction.note')}</p>
          </div>
        </div>
      </section>
      <ContactStrip />
    </div>
  );
};

export default Reaction;
